// src/components/Login.tsx
import { yupResolver } from '@hookform/resolvers/yup';
import { EnterIcon, InfoCircledIcon } from '@radix-ui/react-icons';
import { Avatar, Button, Callout, Card, Flex, Link, Spinner, Text } from '@radix-ui/themes';
import React from 'react';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { useMutation } from 'react-query';

import { useNavigate } from 'react-router-dom';
import TextFieldComponent from '../../../components/inputs/Textfield/TextfieldComponent';
import { routes } from '../../../routes';
import { requestEmailPassword } from '../../../services/forgotPassword/forgotPassword';
import styles from '../../../styles/Login.module.scss';
import { formValidation } from './ForgotPasswordFormValidation';
import { BASE_URL, UPLOAD_IMAGES } from '../../../utils/constants';
import { useIES } from '../../../hooks/useIES';

const ForgotPassword: React.FC = () => {
    const { IES, isLoading } = useIES();
  const navigate = useNavigate();
  const mutation = useMutation({
    mutationFn: requestEmailPassword, mutationKey: 'requestEmailPassword',
    onSuccess: (data) => {
      toast.success("Enviamos um link por favor, verifique o seu email")
    },
    //  onError:(err:any)=>{
    //    toast.error(`${err?.message}`);
    // }
  });
  type FormValues = {
    email: string,
  }
  const defaultValues: FormValues = {
    email: "",
  }
  const { setValue, getValues, watch, control, handleSubmit, reset, formState: { errors }, trigger } = useForm<FormValues>({
    defaultValues,
    resolver: yupResolver(formValidation),
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    shouldUseNativeValidation: false,
  });

  const onSubmit = handleSubmit(async (request) => {
    try {
      await mutation.mutateAsync(request);
    } catch (err: any) {
      toast.error(`${mutation.error ?? err?.message}`);
    }
  });

  return (
    <div className={styles.loginContainer}>
      <div className={styles.imageSection} style={{
    backgroundImage: `url(${IES.BACKGROUND})`
  }}>
        {/* Coloque aqui a imagem desejada */}
        <img src={`${IES.LOGO}`} alt="Login" />
      </div>
      <div className={styles.formSection}>
        <Card size="3" title='Forgot Password' variant='classic' style={{ width: '50%' }}
        >
          <Flex gap="4"
            align="center"
            direction="column"
          >
            <Avatar size="6"
              fallback="T"
              src={`${IES.LOGO}`}
            />
            <Text
              weight={'bold'}
              as='label'
            >
              Resetar senha
            </Text>
            {mutation.isSuccess ?
              <>
                <Callout.Root color="green">
                  <Callout.Icon>
                    <InfoCircledIcon />
                  </Callout.Icon>
                  <Callout.Text>
                    Verifique o seu email para prosseguir com a recuperação da senha.<Link onClick={() => navigate(routes.login)}> Clique aqui para ir ao login!</Link>
                  </Callout.Text>
                </Callout.Root>
              </> : <>
                <form onSubmit={onSubmit} noValidate>
                  <Flex gap="4" direction="column">
                    <TextFieldComponent name="email" label="Email" control={control} errors={errors} fieldProps={{ placeholder: 'Digite o email' }} style={{ width: '100%' }} />

                    <Button variant="surface" type="submit" disabled={mutation.isLoading}>
                      {mutation.isLoading ? <> <Spinner loading> <EnterIcon />  </Spinner> </> : <EnterIcon />} Confirmar
                    </Button>
                  </Flex>
                </form>

              </>}

          </Flex>

        </Card >

      </div>
    </div>

  );
};

export default ForgotPassword;